import { useEffect } from 'react';
import urlParse from 'url-parse';
import { useParams, useHistory } from 'react-router-dom';


import { unshortenUrl } from '../api/global-api';

const ShortLink = () => {
    const { token } = useParams();
    const history = useHistory();

    useEffect(() => {
        if (token) {
            unshortenUrl(token, url => {
                const urlProps = urlParse(url);
                if (urlProps && urlProps.pathname) {
                    history.push(urlProps.pathname);
                } else {
                    history.push(url);
                }
            });
        }
    }, [token]);

    return null;
}

export default ShortLink